import { render } from "./CreateNewTrimModal.vue?vue&type=template&id=2e950ae1"
import script from "./CreateNewTrimModal.vue?vue&type=script&lang=js"
export * from "./CreateNewTrimModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__